export default class userPermissions {
    /** @ngInject */
    constructor($q, $http, authService, $log) {
        this.dependencies = {
            authService: authService,
            $q: $q,
            $http: $http,
            $log: $log
        };

        this.actions = {};
        this.authenticated = Boolean(window.user);

        this.$inProgress = {
            promise: false,
            actions: [] // todo: implement checking
        };

    }

    /**
     * Do a permission check on a single action
     * @param action
     * @param identifier
     * @returns {Promise}
     */
    can(action, identifier) {
        let deferred = this.dependencies.$q.defer();
        this.get([action])
            .then(() => deferred.resolve(!!this.actions[action]))
            .catch(() => deferred.resolve(false))
            .finally(() => this.dependencies.$log.debug('can access ', action, '? :', !!this.actions[action], identifier || ''));
        return deferred.promise;
    }

    /**
     * Find the permission(s) we're looking for,
     * @param actions
     * @param deferredRef
     * @returns {Promise}
     */
    get(actions, deferredRef) {
        let deferred = deferredRef || this.dependencies.$q.defer(),
            actionsToQuery = [];

        if (this.authenticated) {
            actionsToQuery = this.getActionsToQuery(actions);

            if (actionsToQuery.length) {
                this.queryActions(actionsToQuery, deferred);

            } else {
                deferred.resolve();
            }

        } else {
            this.denyAll(actions);
            deferred.resolve();
        }

        return deferred.promise;
    }

    /**
     * Get actions for which we don't already have a grant/deny value for
     * @param actions
     * @returns {Array}
     */
    getActionsToQuery(actions) {
        let actionsToCheck = [];
        angular.forEach(actions, (action) => {
            if (angular.isUndefined(this.actions[action])) {
                actionsToCheck.push(action);
            }
        });
        return actionsToCheck;
    }

    /**
     * Set all actions passed in as deny!
     * @param actions
     */
    denyAll(actions) {
        angular.forEach(actions, (action) => {
            this.actions[action] = false;
        });
    }

    /**
     * Query now, or wait if there's a query in progress
     * todo: replace this with checking if particular actions are being checked
     * todo: wait if they are, otherwise blast away
     * @param actions
     * @param deferred
     */
    queryActions(actions, deferred) {
        if (this.$inProgress.promise) {
            this.$inProgress.promise.finally(() => this.get(actions, deferred));
        } else {
            this.query(actions, deferred);
        }
    }

    /**
     * Hit the Accounts API to do permission check
     * @param actions
     * @param deferred
     */
    query(actions, deferred) {
        this.dependencies.$log.debug('API Check', actions);

        let defaultPerm = {permissions: {}};
        for (let i=0; i<actions.length; i++) {
            defaultPerm.permissions[actions[i]] = false;
        }

        let promise = this.dependencies.authService.checkPermissions({permissions: actions, env: 'staging'})
            .then((response)=> angular.extend(this.actions, response.permissions))
            .finally(() => deferred.resolve(this.actions))
            .catch(() => deferred.resolve(defaultPerm));

        this.$inProgress.promise = promise;
    }
}



// WEBPACK FOOTER //
// ./user/services/user-permissions.js